export const modellingRoutes = (root: string) => ({
  root,
});
